import { render, staticRenderFns } from "./RowExpansionToggle.vue?vue&type=template&id=3612a7cc&scoped=true"
import script from "./RowExpansionToggle.vue?vue&type=script&lang=js"
export * from "./RowExpansionToggle.vue?vue&type=script&lang=js"
import style0 from "./RowExpansionToggle.vue?vue&type=style&index=0&id=3612a7cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3612a7cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
